import React, {useState} from 'react';
import { useNavigate } from 'react-router-dom';
import {useSnackbar} from "notistack";
import apiClient from "../../../api/apiClient";
import {useAuthStore, useCampStore} from "../../../stores";
import {CAMP_CODE} from "../../../schema/Environment";

export default function AuthLogin () {
    const navigate = useNavigate();
    const { enqueueSnackbar } = useSnackbar();
    const [currentUsername, setCurrentUsername] = useState("");
    const [currentPassword, setCurrentPassword] = useState("");
    const setToken = useAuthStore((state) => state.setToken);
    const setCamp = useCampStore((state) => state.setCamp);

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const response = await apiClient.post('/api/users/public/auth/login', {
                username: currentUsername.trim(),
                password: currentPassword.trim()
            }, {
                headers: { 'X-Camp-Code': CAMP_CODE }
            });
            if (response.data.role !== 'ORG') {
                enqueueSnackbar('Доступ в админ-панель только для организаторов', { variant: 'error' });
                return;
            }
            setToken(response.data.accessToken);
            sessionStorage.setItem('userId', response.data.userId);
            sessionStorage.setItem('refreshToken', response.data.refreshToken);
            if (response.data.campId) {
                setCamp({ campId: response.data.campId });
            }
            navigate('/', { replace: true });
        } catch (error) {
            enqueueSnackbar(error.response?.data?.message || 'Ошибка авторизации', { variant: 'error' });
        }
    }

    return (
        <form className="login-form" onSubmit={handleSubmit}>
            <input
                className="login-input"
                id="username"
                value={currentUsername}
                placeholder="Имя пользователя"
                autoComplete="username"
                onChange={e => setCurrentUsername(e.target.value)}
            />
            <input
                className="login-input"
                id="password"
                type="password"
                value={currentPassword}
                placeholder="Пароль"
                autoComplete="current-password"
                onChange={e => setCurrentPassword(e.target.value)}
            />
            <button type="submit" className="login-btn">Войти</button>
        </form>
    )
}
